/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IQueryConfigurationScope extends angular.IScope {
        model: models.QueryConfigurationModel
    }


    export class QueryConfigurationController implements IController {
        constructor(
            private scope: IQueryConfigurationScope,
            queryConfigurationService: services.QueryConfigurationService,
            systemLevelService: services.SystemLevelService,
            dataSourceService: services.DataSourceService,
            treeService: services.TreeService, 
            tagService: services.TagService,
            $q: angular.IQService,
            $routeParams: angular.route.IRouteParamsService)
        {
            var id = null;
            if ($routeParams["id"]){
                id = $routeParams["id"];
            }

            this.scope.model = new models.QueryConfigurationModel(queryConfigurationService, systemLevelService, treeService, tagService, $q, id);
        }
    }
}

warsApp.registerController('QueryConfigurationController', [
    '$scope', 'queryConfigurationService', 'systemLevelService', 'dataSourceService', 'treeService', 'tagService', '$q', '$routeParams'
]);